module.exports = __webpack_public_path__ + "static/media/tutor-th-4.1fc899a7.jpg";